import { render } from "./PrimaryNavigation.vue?vue&type=template&id=0f9f1a39"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__